<template>
  <div style="padding: 10px 10px 0;">
    <div style="display: flex">
      <date-time-picker
        :timeType="timeType"
        ref="date_time_picker"
        @dateRangeChange="v => (dateRange = v)"
      ></date-time-picker>

      <a-radio-group
        v-model="sensortype"
        button-style="solid"
        size="small"
        style="margin-left: 16px"
      >
        <a-radio-button
          :value="item.value"
          v-for="item in sensortypes"
          :key="item.value"
          >{{ item.label }}</a-radio-button
        >
      </a-radio-group>

      <a-radio-group
        v-model="timeType"
        button-style="solid"
        size="small"
        style="margin-left: 16px"
      >
        <a-radio-button
          :value="item.value"
          v-for="item in timeTypes"
          :key="item.value"
          >{{ item.label }}</a-radio-button
        >
      </a-radio-group>
      <a-button
        type="primary"
        size="small"
        style="margin-left: 16px"
        @click="exportAll"
        :loading="loading"
        v-if="userMenuPower.controls.exportAll"
      >
        导出全部
      </a-button>
      <div
        style="margin-left: 16px"
        v-if="userMenuPower.controls.enableUpdateMinMax"
      >
        最小值：<a-input style="width: 60px" size="small" v-model="chartMin" />
        最大值：<a-input style="width: 60px" size="small" v-model="chartMax" />
        标准值：<a-select
          style="width: 212px"
          size="small"
          v-model="waterNorm"
          mode="multiple"
        >
          <a-select-option
            v-for="item in waterNormOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div :style="{ display: 'flex', padding: '10px 0', height: contentHeight }">
      <group-tree
        :style="{
          height: '100%',
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          width: isShowTree ? '280px' : '36px'
        }"
        @showTree="v => (isShowTree = v)"
      ></group-tree>
      <a-divider
        type="vertical"
        style="height: auto; margin: 0 2px;width: 2px"
      />
      <history-plot
        style="flex: 1"
        :timeType="timeType"
        :sensortype="sensortype"
        :dateRange="dateRange"
        :isShowTree="isShowTree"
        :chartMin="chartMin"
        :chartMax="chartMax"
        :waterNorm="waterNorm"
        @resetMinMax="
          chartMin = null;
          chartMax = null;
        "
      ></history-plot>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DateTimePicker from "@/components/DateTimePicker";
import GroupTree from "./components/GroupTree";
import HistoryPlot from "./components/HistoryPlot";
import { timeTypes, waterValueV, waterNormOptions } from "@/options/common";
import { isCheckNumber } from "@/utils/utils";
import moment from "moment";
import XLSX from "xlsx";
import _ from "lodash";
export default {
  data() {
    return {
      timeTypes,
      timeType: "min",
      sensortype: "pm10",
      dateRange: [moment().subtract(2, "hours"), moment()],
      isShowTree: true,
      chartMin: null,
      chartMax: null,
      waterNormOptions,
      waterNorm: [],
      loading: false,
      contentHeight: 0
    };
  },
  components: {
    DateTimePicker,
    GroupTree,
    HistoryPlot
  },
  computed: {
    ...mapState([
      "sensortypes",
      "userMenuPower",
      "checkedHistoryStationIds",
      "historyData"
    ]),
    ...mapGetters(["defaultInfo"])
  },
  created() {
    if (this.userMenuPower.controls.enableUpdateMinMax) {
      this.waterNorm = ["V"];
    }
    this.getContentHeight();
  },
  mounted() {
    window.addEventListener("resize", this.getContentHeight);
    this.sensortype = this.defaultInfo.defaultSensorType;
    this.dateRange = this.$refs.date_time_picker.dateRange;
  },
  destroyed() {
    window.removeEventListener("resize", this.getContentHeight);
  },
  methods: {
    getContentHeight() {
      const innerHeight = window.innerHeight;
      this.contentHeight = innerHeight - 108.5 + "px";
    },
    exportAll() {
      if (!this.checkedHistoryStationIds.length) {
        this.$message.warning("请至少选中一个微站站点");
        return;
      }

      console.time("export");
      this.loading = true;
      let exportStationList = this.historyData.filter(x =>
        this.checkedHistoryStationIds.includes(Number(x.id))
      );
      // 按照以下station_id排序导出数据
      const ids_sort_rule = [718, 719, 731, 722, 723, 707, 724, 726, 725, 727];
      const sort_arr = [];
      ids_sort_rule.forEach(x => {
        let info = exportStationList.find(y => Number(y.id) == x);
        if (!!info) {
          sort_arr.push(info);
        }
      });
      let extra_arr = exportStationList.filter(
        x => !ids_sort_rule.includes(Number(x.id))
      );
      exportStationList = sort_arr.concat(extra_arr);
      // 时间去重排序
      let timeList = _.orderBy(
        _.uniq(
          exportStationList
            .map(x => x.datas)
            .flat()
            .map(y => y[0])
        )
      );
      const valueVInfos = waterValueV.reduce((acc, x) => {
        acc[x.value] = x;
        return acc;
      }, {});
      const aoaObj = {};
      this.sensortypes.forEach(x => {
        aoaObj[x.value] = [];
      });
      const tableHead = ["日期", "时段"];
      for (const item of exportStationList) {
        tableHead.push(item.station[0].name);
      }
      for (const t of timeList.entries()) {
        const idx = t[0],
          curTime = t[1];
        for (const item of exportStationList) {
          const curInfo = item.datas.find(x => x[0] == curTime);
          this.sensortypes.forEach(s => {
            const valueVInfo = valueVInfos[s.value];
            const index = item.columns.findIndex(x => x == s.value);
            let curValue = this.$sr(s.value, curInfo?.[index]);
            curValue = isCheckNumber(curValue) ? Number(curValue) : null;
            if (!aoaObj[s.value][idx]) {
              aoaObj[s.value][idx] = [
                moment(curTime).format("MM/DD"),
                moment(curTime).format("H:mm"),
                curValue
              ];
            } else {
              aoaObj[s.value][idx].push(curValue);
            }
            if (!!valueVInfo) {
              if (valueVInfo.value !== "ph") {
                if (
                  aoaObj[s.value][idx]?.length ==
                  exportStationList.length + 2
                ) {
                  aoaObj[s.value][idx].push(valueVInfo.value_V);
                }
              }
            }
          });
        }
      }

      const dayCountList = Object.values(
        timeList.reduce((acc, time) => {
          const dayKey = moment(time).format("YYYY-MM-DD");
          acc[dayKey] = (acc[dayKey] || 0) + 1;
          return acc;
        }, {})
      );

      const workbook = XLSX.utils.book_new();
      for (const key in aoaObj) {
        const s = this.sensortypes.find(x => x.value == key);
        const valueVInfo = valueVInfos[s.value];
        if (!!valueVInfo && valueVInfo.value !== "ph") {
          aoaObj[s.value].unshift([...tableHead, s.label + "V类水质标准"]);
        } else {
          aoaObj[s.value].unshift(tableHead);
        }
        const worksheet = XLSX.utils.aoa_to_sheet(aoaObj[key]);
        worksheet["!merges"] = dayCountList.map((count, index) => {
          const startRow =
            1 + dayCountList.slice(0, index).reduce((acc, cur) => acc + cur, 0);
          const endRow = startRow + count - 1;
          // 彻底移除除了左上角之外，被合并区域内的所有底层值，和excel的合并功能一致
          for (let r = startRow + 1; r <= endRow; r++) {
            const addr = XLSX.utils.encode_cell({ r, c: 0 });
            delete worksheet[addr];
          }
          return {
            s: { c: 0, r: startRow },
            e: { c: 0, r: endRow }
          };
        });
        XLSX.utils.book_append_sheet(workbook, worksheet, s.label);
      }
      XLSX.writeFile(
        workbook,
        `${moment(this.dateRange[0]).format("YYYY-MM-DD_HH时mm分")}至${moment(
          this.dateRange[1]
        ).format("YYYY-MM-DD_HH时mm分")}数据.xlsx`
      );
      this.loading = false;
      console.timeEnd("export");
    }
  }
};
</script>

<style></style>
